<template>
  <div
    class="tw-flex tw-max-w-full tw-gap-2 tw-cursor-pointer"
    :class="containerClass"
    data-testid="adjustments-account-filled"
    tabindex="0"
    @click="editSelectedAccount"
    @focus="editSelectedAccount"
  >
    <AdjustmentsAccountItem
      :label="originalAccountIdentifier"
      :name="accountIdentifier"
      :grow="true"
    ></AdjustmentsAccountItem>
    <div class="tw-flex tw-items-center">
      <span :class="iconClasses" data-testid="adjustments-account-edit">
        <i class="icon icon-pencil tw-min-w-0"></i>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type {
  SubAdjustmentRowAccount,
  SubAdjustmentRowAccountNew,
} from '@app/application/adjustments/types'

import { computed } from 'vue'

import AdjustmentsAccountItem from './adjustments-account-item.vue'

interface Props {
  account: SubAdjustmentRowAccount
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  account: () => ({} as SubAdjustmentRowAccountNew),
})

const emit =
  defineEmits<{
    'update:modelValue': [value: SubAdjustmentRowAccount]
    'edit-selected-account': [value: boolean]
  }>()

const containerClass = computed(() => {
  return {
    'tw-max-h-[30px]':
      accountIdentifier.value && !originalAccountIdentifier.value,
    'tw-py-1.5': accountIdentifier.value && !originalAccountIdentifier.value,
  }
})

const iconClasses = computed(() => {
  return {
    'tw-text-sf-gray-darker': !props.disabled,
    'tw-text-sf-gray-lighter': props.disabled,
    '!tw-cursor-not-allowed': props.disabled,
  }
})

const accountIdentifier = computed(() => {
  if (!props.account.number || !props.account.name) {
    return ''
  }

  return `${props.account.number} ${props.account.name}`
})

const originalAccountIdentifier = computed(() => {
  if (!props.account.originalNumber && !props.account.originalName) {
    return ''
  }

  return `${props.account.originalNumber ?? props.account.number} ${
    props.account.originalName ?? props.account.name
  }`
})

const editSelectedAccount = (): void => {
  emit('edit-selected-account', true)
}
</script>
